/* Pattern for ad hoc query against relay store */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
      
  const query = graphql`
  query VendorTransactionsFetchQuery($startDate: Datetime, $endDate: Datetime, $accountName: String, $pAccountId: UUID, $vendorAccountId: UUID, $first: Int, $offset: Int) {
    getvendorresellerbindcardchargeswithsummary2(startTs: $startDate, endTs: $endDate, accountName: $accountName, pAccountId: $pAccountId, vendorAccountId: $vendorAccountId, first: $first, offset: $offset) {
      totalCount
      nodes {
        bcChargeSum
        rebateSum
        customerAccountName
        customerAppStatus
        appId
        appName
        appLogo
        transactionId
        transactionTime
        bindCardCharge
        rebate
      }
    }
  }
  `;

  function fetch(startDate, endDate, accountName, pAccountId, vendorAccountId, first, offset) {
    const variables = {
        startDate: startDate, 
        endDate: endDate, 
        accountName: accountName, 
        pAccountId: pAccountId, 
        vendorAccountId: vendorAccountId, 
        first: first, 
        offset: offset
    }
    
    return fetchQuery(
        abEnvironment.getEnvironment(),
        query,
        variables
    );
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { fetch };
